export const VoskSendConfigService = {
  sendEOF: (webSocket: WebSocket | null) => {
    webSocket?.send(JSON.stringify({ eof: 1 }))
  },
  sendModel: (webSocket: WebSocket | null, modelPath: string) => {
    webSocket?.send(
      JSON.stringify({
        config: { model: modelPath },
      }),
    )
  },
  sendShowWords: (webSocket: WebSocket | null, showWords: boolean) => {
    webSocket?.send(
      JSON.stringify({
        config: { words: showWords },
      }),
    )
  },
  sendSampleFormat: (webSocket: WebSocket | null, sampleFormat: string) => {
    webSocket?.send(
      JSON.stringify({
        config: { sample_format: sampleFormat },
      }),
    )
  },
  sendSampleRate: (webSocket: WebSocket | null, sampleRate: number) => {
    webSocket?.send(
      JSON.stringify({
        config: { sample_rate: sampleRate },
      }),
    )
  },
  sendChunkLength: (webSocket: WebSocket | null, chunkLength: number) => {
    webSocket?.send(
      JSON.stringify({
        config: { chunklen: chunkLength },
      }),
    )
  },
  sendClientTimestamp: (webSocket: WebSocket | null, milliseconds: number) => {
    webSocket?.send(
      JSON.stringify({
        ts: { s: Math.trunc(milliseconds / 1000), ms: milliseconds % 1000 },
      }),
    )
  },
  sendAudioLogging: (webSocket: WebSocket | null, isAllowed: boolean) => {
    webSocket?.send(
      JSON.stringify({
        config: { audio_log: isAllowed },
      }),
    )
  },
}
